import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';
import { FlexBoxCol } from '@ertelecom/ui-react/components/layouts/flexBoxGrid';

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  border-radius: 8px;
  min-height: 472px;
  height: calc(100% - 16px);
  margin-bottom: 16px;
  background: ${COLORS.white};
  transition: 0.3s;
  margin: 0 auto ${props => props.oneRow ? '0' : '48px'};
  min-height: ${props => props.oneRow ? '528px' : 'auto'};

  @media (max-width: 48em) {
    max-width: 100%;
    margin: 0 auto ${props => props.oneRow ? '0' : '16px'};
  }

  :hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.07);
  }
`;

export const HeaderBlock = styled.div`
    height: 40px;
    width: 100%;
`;

export const DescriptionBlock = styled.div`
  display: flex;
  flex-direction: row;
  font-family: ${FONTS.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${COLORS.darkGrey};
  margin-top: 0;
  margin-bottom: 3px;
  flex-grow: 4;
`;

export const PurchaseBlock = styled.div`
    display: block;
    margin-top: 24px;
    
    @media(max-width: 768px) {
        margin-top: 64px;
    }
`;

export const ImageBlock = styled.div`
    height: 150px;
    width: 100%;
    margin-bottom: 16px;
    
    a {
        display: inline-block;
        height: 100%;
        margin: 0 auto;
        overflow: hidden;
    }
    
    img {
        height: 100%;
    }
`;

export const TitleBlock = styled.div`
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    z-index: 2;
    margin-bottom: 16px;
    display: block;
    
    &:hover {
        overflow: visible;
        white-space: normal;
    }
    @media (max-width: 530px) {
        font-size: 16px;
    }
`;

export const Col = styled(FlexBoxCol)`
    display: ${props => props.display || 'block'};
    min-height: ${props => props.oneRow ? '528px' : 'auto'};
`;
